import React from 'react';
// import PropTypes from 'prop-types';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CardBody from '../../shared/components/CardBody';
import Paginator from '../../shared/components/Paginator';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import UsersTable from './UsersTable';
import * as userActions from '../actions/userActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import StateManager from '../../shared/utils/StateManager';
import { CurrentUser } from '../../shared/model/CurrentUser';
import UserRole from '../../shared/model/UserRole';

class UsersCard extends React.Component {

    STATE_MANAGER_KEY = 'USERS_CARD';

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);

        this.state = StateManager.getState(this.STATE_MANAGER_KEY);
    }

    componentWillMount() {
        this.props.userActions.getUserRoles();
        this.getUsers();
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search
            || prevState.filter !== this.state.filter
            || prevState.page !== this.state.page ) {
            this.getUsers();
        }
        StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
    }

    getUsers() {
        let filter = this.state.filter;

        if ( !Array.isArray(this.state.filter) && this.state.filter === 0 ) { // 0 -> devuelve todos
            if ( this.props.currentUserRole === UserRole.SUPERADMIN ) {
                filter = [
                    UserRole.SUPERADMIN,
                    UserRole.ADMIN,
                ];
            }
            if ( this.props.currentUserRole === UserRole.ADMIN ) {
                filter = [
                    UserRole.ADMIN,
                    UserRole.OUTSOURCES_MANAGER,
                    UserRole.OUTSOURCES_VIEWER,
                    UserRole.CONTRACTORS_MANAGER,
                    UserRole.LISTERIA_MANAGER,
                ];
            }
        }

        this.props.userActions.getUsers(this.state.page, this.state.search, filter);
    }

    onRefresh() {
        this.getUsers();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    renderFilterName() {
        const states = _.keyBy(this.props.userRoles, 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].name;
        }
        return '';
    }

    renderHeaderOptions() {
        const filterOptions = this.props.userRoles.map((userRole) => {
            return {
                title: userRole.name,
                active: userRole.id === this.state.filter,
                onClick: () => {
                    this.setState({ filter: userRole.id, page: 1 });
                },
            };
        });

        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                filterOptions={filterOptions}
                onSearch={this.onSearch}
                searchText={this.state.search}
            />
        );
    }

    render() {
        const {
            usersLoading,
            users,
            usersError,
            usersPagination,
        } = this.props;

        return (
            <Row clearfix>
                <Card loading={usersLoading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODOS_LOS_USUARIOS').toUpperCase()}
                        subtitle={this.renderFilterName()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        <UsersTable
                            data={users}
                            error={usersError}
                        />
                        <Paginator
                            data={usersPagination}
                            onPage={this.onPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = state => {
    let errorMessage = state.users.usersError;
    if ( !errorMessage && state.users.users.length === 0 && !state.users.usersLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }

    let userRolesState = state.users.userRoles;

    const currentUserRole = CurrentUser.fromReduxState(state).role();
    const defaultRoles = [];
    if ( currentUserRole === UserRole.SUPERADMIN ) {
        defaultRoles.push(UserRole.SUPERADMIN, UserRole.ADMIN);
        userRolesState = userRolesState.filter(role => defaultRoles.includes(role.id));
    } else if ( currentUserRole === UserRole.ADMIN ) {
        userRolesState = userRolesState.filter(role => role.id !== UserRole.SUPERADMIN);
    }

    if ( !_.keyBy(userRolesState, 'id')[0] ) {
        userRolesState.unshift({
            'id': 0,
            'name': I18nUtils.tr('TR_TODOS'),
        });
    }

    return ( {
        users: state.users.users,
        usersPagination: state.users.usersPagination,
        usersLoading: state.users.usersLoading,
        usersError: errorMessage,
        userRoles: userRolesState,
        currentUserRole,
    } );
};

const mapDispatchToProps = dispatch => ( {
    userActions: bindActionCreators(userActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(UsersCard);

UsersCard.propTypes = {};

UsersCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/users/components/UsersCard.jsx